import { render } from "./VideoPlayerControlsSettingsDropdown.vue?vue&type=template&id=1769abb3&scoped=true"
import script from "./VideoPlayerControlsSettingsDropdown.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsSettingsDropdown.vue?vue&type=script&lang=js"

import "./VideoPlayerControlsSettingsDropdown.vue?vue&type=style&index=0&id=1769abb3&lang=scss&scoped=true"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1769abb3"]])

export default __exports__